// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

const Review: React.FunctionComponent<any> = (props) => {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 18 18" {...props}>
            <g id="Review-Asrt-v2">
                <g id="Styles-x-Door-v1.02D" transform="translate(-285.000000, -119.000000)">
                    <g id="toolbar-48" transform="translate(0.000000, 104.000000)">
                        <g id="Group-3-Copy-4" transform="translate(260.000000, 0.000000)">
                            <g id="icon-review-18" transform="translate(25.000000, 15.000000)">
                                <rect style={{ fill: "none" }} width="24" height="24" />
                                <g>
                                    <path
                                        d="M17.5,16.5L14,12.9c1.1-1.3,1.8-3.1,1.8-4.9c0-4.3-3.5-7.8-7.8-7.8S0.2,3.7,0.2,8s3.5,7.8,7.8,7.8
							c1.9,0,3.6-0.7,4.9-1.8l3.5,3.5c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2C17.8,17.2,17.8,16.8,17.5,16.5z M1.8,8
							c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2s-2.8,6.2-6.2,6.2S1.8,11.4,1.8,8z"
                                    />
                                    <path
                                        d="M10.4,5.5L7.2,9.4L5.5,7.7c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1L6.7,11c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0,0,0,0
							c0.2,0,0.4-0.1,0.5-0.3l3.8-4.5c0.3-0.3,0.2-0.8-0.1-1.1C11.2,5.2,10.7,5.2,10.4,5.5z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

export default Review;
